import { render, staticRenderFns } from "./CurrentLpoGeometry__addPoint.vue?vue&type=template&id=0b6f0c5e&scoped=true&"
import script from "./CurrentLpoGeometry__addPoint.vue?vue&type=script&lang=js&"
export * from "./CurrentLpoGeometry__addPoint.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLpoGeometry__addPoint.vue?vue&type=style&index=0&id=0b6f0c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f0c5e",
  null
  
)

export default component.exports